module.exports = __webpack_public_path__ + "img/pic_jdyth.4a3f68e3.png";